export default "__VITE_ASSET__$RK$nK$E__"